import toInteger from "../_lib/toInteger/index.js";
import addBusinessDays from "../addBusinessDays/index.js";
import requiredArgs from "../_lib/requiredArgs/index.js";
/**
 * @name subBusinessDays
 * @category Day Helpers
 * @summary Substract the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of business days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @param {Object} [options] - an object with options.
 * @param {Number[]} [options.businessDays=[1, 2, 3, 4, 5]] - the business days. default is Monday to Friday.
 * @param {Record<string, boolean>} [options.exceptions={}] - exceptions to the business days. Map of date string (with format "MM/DD/YY") to boolean.
 * @returns {Date} the new date with the business days subtracted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} businessDays cannot include numbers greater than 6
 *
 * @example
 * // Substract 10 business days from 1 September 2014:
 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
 */

export default function subBusinessDays(dirtyDate, dirtyAmount, dirtyOptions) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var options = dirtyOptions || {};
  var businessDays = options.businessDays || [1, 2, 3, 4, 5];
  var exceptions = options.exceptions || {}; // Throw a RangeError if businessDays includes a number greater than 6

  if ((businessDays === null || businessDays === void 0 ? void 0 : businessDays.filter(function (number) {
    return number > 6;
  }).length) > 0) {
    throw new RangeError('business days must be between 0 and 6');
  }

  return addBusinessDays(dirtyDate, -amount, {
    businessDays: businessDays,
    exceptions: exceptions
  });
}